import { render, staticRenderFns } from "./cardRegistration.vue?vue&type=template&id=c8a90c3a"
import script from "./cardRegistration.vue?vue&type=script&lang=js"
export * from "./cardRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports